import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useFocus } from "src/hooks/useElementFocus";

const animateNext = {
  initial: { x: "50%", opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: "-50%", opacity: 0 }
};

const animatePrevious = {
  initial: { x: "-50%", opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: "50%", opacity: 0 }
};

const animations = {
  next: animateNext,
  previous: animatePrevious
};

export default function SceneAnimation({ children, direction = "next" }) {
  const focus = useFocus();
  const animation = animations[direction];

  return (
    <motion.div
      variants={animation}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3 }}
      onAnimationStart={focus.beforeNavigation}
      onAnimationComplete={focus.afterNavigation}
    >
      <Box w="100%" h="424px" position="absolute">
        {children}
      </Box>
    </motion.div>
  );
}
